import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import { getComponentFromProp } from '../_util/props-util';
import PropTypes from '../_util/vue-types';
import BaseMixin from '../_util/BaseMixin';
import getTransitionProps from '../_util/getTransitionProps';

var SelectTag = {
  mixins: [BaseMixin],
  props: {
    prefixCls: PropTypes.string.def('rc-select-tag'),
    selectorValueList: PropTypes.array,
    maxTagTextLength: PropTypes.number,
    maxTagCount: PropTypes.number,
    maxTagPlaceholder: PropTypes.any,
    choiceTransitionName: PropTypes.string,
    removeIcon: PropTypes.any
  },
  methods: {
    removeSelected: function removeSelected(event, item) {
      this.__emit('remove', event, item);
    },
    onChoiceAnimationLeave: function onChoiceAnimationLeave() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.__emit.apply(this, ['choiceAnimationLeave'].concat(_toConsumableArray(args)));
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var _$props = this.$props,
        prefixCls = _$props.prefixCls,
        maxTagPlaceholder = _$props.maxTagPlaceholder,
        maxTagTextLength = _$props.maxTagTextLength,
        maxTagCount = _$props.maxTagCount,
        choiceTransitionName = _$props.choiceTransitionName,
        _$props$selectorValue = _$props.selectorValueList,
        selectorValueList = _$props$selectorValue === undefined ? [] : _$props$selectorValue;


    var removeIcon = getComponentFromProp(this, 'removeIcon');
    var selectedValueNodes = [];
    var limitedCountValue = selectorValueList;
    var maxTagPlaceholderEl = void 0;
    if (maxTagCount !== undefined && selectorValueList.length > maxTagCount) {
      limitedCountValue = limitedCountValue.slice(0, maxTagCount);
      var omittedValues = selectorValueList.slice(maxTagCount, selectorValueList.length);
      var content = '+ ' + (selectorValueList.length - maxTagCount);
      if (maxTagPlaceholder) {
        content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
      }
      var attrs = {
        role: 'presentation',
        title: typeof content === 'string' ? content : ''
      };
      maxTagPlaceholderEl = h(
        'li',
        _mergeJSXProps([{ attrs: attrs }, {
          'class': prefixCls + '-selection__choice ' + prefixCls + '-selection__choice__disabled',
          key: 'maxTagPlaceholder'
        }]),
        [h(
          'div',
          { 'class': prefixCls + '-selection__choice__content' },
          [content]
        )]
      );
    }
    selectedValueNodes = limitedCountValue.map(function (o) {
      var info = o;
      var content = info.label;
      var title = info.title || content;
      if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
        content = content.slice(0, maxTagTextLength) + '...';
      }
      var disabled = o.disabled;

      var choiceClassName = disabled ? prefixCls + '-selection__choice ' + prefixCls + '-selection__choice__disabled' : prefixCls + '-selection__choice';

      var attrs = {
        role: 'presentation',
        title: title
      };
      return h(
        'li',
        _mergeJSXProps([{ attrs: attrs }, { 'class': choiceClassName, key: info.key || info.value }]),
        [h(
          'div',
          { 'class': prefixCls + '-selection__choice__content' },
          [content]
        ), disabled ? null : h(
          'span',
          {
            on: {
              'click': function click(event) {
                _this.removeSelected(event, o);
              }
            },

            'class': prefixCls + '-selection__choice__remove'
          },
          [removeIcon || h(
            'i',
            { 'class': prefixCls + '-selection__choice__remove-icon' },
            ['\xD7']
          )]
        )]
      );
    });
    if (maxTagPlaceholderEl) {
      selectedValueNodes.push(maxTagPlaceholderEl);
    }
    var transitionProps = getTransitionProps(choiceTransitionName, {
      tag: 'ul',
      afterLeave: this.onChoiceAnimationLeave
    });

    var innerNode = h(
      'transition-group',
      transitionProps,
      [selectedValueNodes]
    );
    return innerNode;
  }
};

export default SelectTag;